/* ============================================================
   ALANKAR JEWELLERS — MASTER CATALOG
   ------------------------------------------------------------
   Everything on the site is driven from THIS file.
     - CATEGORIES : top-level (Gold, Silver, Rose Gold, Diamond,
                    Temple & Antique)
     - subCategories : e.g. Rings, Bangles, Chains, Necklaces...
     - images  : ONLY photos matching the sub-category name
                 (rings-only in rings, bangles-only in bangles).
                 Replace with real product photos anytime.
     - videos  : each design gets a video (currently cycles the
                 4 videos supplied by the owner - marked below).
     - styleNames : used to auto-name designs 001..054 per sub.
   Edit any string / URL here and the whole site updates.
   ============================================================ */

// ---------------- VIDEOS (owner uploaded) ----------------
const V_OWN_1 = "https://customer-assets.emergentagent.com/job_gold-shine-pune/artifacts/ocouzlj9_gemini_generated_video_C9D1C25A.MP4";
const V_OWN_2 = "https://customer-assets.emergentagent.com/job_gold-shine-pune/artifacts/hv6jpida_gemini_generated_video_C79F672C%202.MP4";
const V_OWN_3 = "https://customer-assets.emergentagent.com/job_gold-shine-pune/artifacts/ibcmihw7_gemini_generated_video_C832D9FE.MP4";
const V_OWN_4 = "https://customer-assets.emergentagent.com/job_gold-shine-pune/artifacts/dkj95mnk_gemini_generated_video_C832D9FE.MP4";
export const VIDEO_POOL = [V_OWN_1, V_OWN_2, V_OWN_3, V_OWN_4];

// ---------------- STRICT IMAGE POOLS ----------------
// (only verified working images — each pool matches its product type)

// RINGS  (single ring / band shots)
const RING_IMAGES = [
  "https://images.unsplash.com/photo-1622398925373-3f91b1e275f5?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1605100804763-247f67b3557e?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1589674781759-c21c37956a44?auto=format&fit=crop&w=800&q=80",
  "https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg?auto=compress&cs=tinysrgb&w=800",
];

// CHAINS  (chain / necklace-chain shots)
const CHAIN_IMAGES = [
  "https://images.unsplash.com/photo-1611107683227-e9060eccd846?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1605884878538-6468614df578?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1771734065116-61e16b353ded?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1589128777073-263566ae5e4d?auto=format&fit=crop&w=800&q=80",
];

// EARRINGS (jhumka / dangler / drop shots)
const EARRING_IMAGES = [
  "https://images.unsplash.com/photo-1714733831162-0a6e849141be?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1617038220319-276d3cfab638?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1629224316810-9d8805b95e76?auto=format&fit=crop&w=800&q=80",
];

// JHUMKAS (traditional Indian jhumka)
const JHUMKA_IMAGES = [
  "https://images.unsplash.com/photo-1714733831162-0a6e849141be?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1617038220319-276d3cfab638?auto=format&fit=crop&w=800&q=80",
];

// STUD / TOP EARRINGS
const STUD_IMAGES = [
  "https://images.unsplash.com/photo-1693212793204-bcea856c75fe?auto=format&fit=crop&w=800&q=80",
];

// BANGLES / BRACELETS
const BANGLE_IMAGES = [
  "https://images.pexels.com/photos/37485309/pexels-photo-37485309.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1639065643006-e217c4fee12e?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1721034909472-390b9325f415?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&w=800&q=80",
];

// NECKLACES (heavy ornate sets)
const NECKLACE_IMAGES = [
  "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1601121141418-c1caa10a2a0b?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1589128777073-263566ae5e4d?auto=format&fit=crop&w=800&q=80",
];

// TEMPLE / ANTIQUE SETS
const TEMPLE_IMAGES = [
  "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1714733831162-0a6e849141be?auto=format&fit=crop&w=800&q=80",
];
const ANTIQUE_IMAGES = [
  "https://images.unsplash.com/photo-1601121141418-c1caa10a2a0b?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&w=800&q=80",
];

// SILVER MURTI  (placeholder — please replace with real murti photos)
const MURTI_IMAGES = [
  "https://images.unsplash.com/photo-1615719413546-198b25453f85?auto=format&fit=crop&w=800&q=80",
  "https://images.unsplash.com/photo-1567407631455-a8b8e6c37ff8?auto=format&fit=crop&w=800&q=80",
];

// ---------------- CATEGORIES ----------------
export const CATEGORIES = [
  {
    slug: "gold",
    label: "Gold",
    tagline: "22k, 18k & 24k — Italian, Turkish, and Indian designs.",
    cover: NECKLACE_IMAGES[0],
    subCategories: [
      { slug: "rings",     label: "Gold Rings",    images: RING_IMAGES,     styleNames: ["Italian Band", "Turkish Cut", "German Solitaire", "Classic Round", "Bridal Setting", "Everyday Band"] },
      { slug: "bangles",   label: "Gold Bangles",  images: BANGLE_IMAGES,   styleNames: ["Kada", "Pipe Bangle", "Filigree", "Meenakari", "Antique Finish", "Bridal Set"] },
      { slug: "chains",    label: "Gold Chains",   images: CHAIN_IMAGES,    styleNames: ["Italian Rope", "Gope Chain", "Turkish Braid", "Box Chain", "Curb Chain", "Byzantine"] },
      { slug: "jhumkas",   label: "22k Gold Jhumkas", images: JHUMKA_IMAGES, styleNames: ["Bridal Jhumka", "South Indian", "Kundan Jhumka", "Antique Jhumka", "Chandbali", "Pearl Drop"] },
      { slug: "earrings",  label: "Gold Earrings", images: EARRING_IMAGES,  styleNames: ["Chandelier", "Hoop", "Drop", "Danglers", "Statement", "Everyday"] },
      { slug: "tops",      label: "Gold Tops",     images: STUD_IMAGES,     styleNames: ["Round Stud", "Floral Top", "Diamond Kissed", "Pearl Top", "Cluster", "Bali"] },
      { slug: "necklaces", label: "Gold Necklaces", images: NECKLACE_IMAGES, styleNames: ["Choker", "Long Chain Set", "Bridal Set", "Layered", "Rani Haar", "Temple Necklace"] },
    ],
  },
  {
    slug: "silver",
    label: "Silver",
    tagline: "Everyday, festive & 92.5 sterling silver.",
    cover: CHAIN_IMAGES[1],
    subCategories: [
      { slug: "rings",    label: "Silver Rings",    images: RING_IMAGES,    styleNames: ["Oxidised Band", "Sterling Solitaire", "Statement Ring", "Toe Ring", "Everyday", "Couple Band"] },
      { slug: "chains",   label: "Silver Chains",   images: CHAIN_IMAGES,   styleNames: ["Box Chain", "Curb Chain", "Snake Chain", "Rope Chain", "Figaro", "Byzantine"] },
      { slug: "earrings", label: "Silver Earrings", images: EARRING_IMAGES, styleNames: ["Studs", "Hoops", "Danglers", "Oxidised Jhumka", "Ear Cuff", "Chandbali"] },
      { slug: "bangles",  label: "Silver Bangles",  images: BANGLE_IMAGES,  styleNames: ["Kada", "Pipe Bangle", "Meenakari", "Bracelet", "Payal Bangle", "Antique Finish"] },
      { slug: "murti",    label: "92.5 Silver Murti", images: MURTI_IMAGES,   styleNames: ["Ganesha", "Lakshmi", "Krishna", "Radha-Krishna", "Balaji", "Saraswati"] },
    ],
  },
  {
    slug: "rose-gold",
    label: "Rose Gold",
    tagline: "Contemporary 18k rose gold pieces.",
    cover: RING_IMAGES[1],
    subCategories: [
      { slug: "rings",    label: "Rose Gold Rings",    images: RING_IMAGES,    styleNames: ["Solitaire", "Twist Band", "Halo", "Eternity", "Stackable", "Statement"] },
      { slug: "chains",   label: "Rose Gold Chains",   images: CHAIN_IMAGES,   styleNames: ["Delicate Chain", "Rope Chain", "Curb", "Box", "Herringbone", "Beaded"] },
      { slug: "earrings", label: "Rose Gold Earrings", images: EARRING_IMAGES, styleNames: ["Hoops", "Studs", "Drops", "Danglers", "Ear Climbers", "Statement"] },
      { slug: "bangles",  label: "Rose Gold Bangles",  images: BANGLE_IMAGES,  styleNames: ["Sleek Bangle", "Cuff", "Chain Bracelet", "Charm Bracelet", "Twist Bangle", "Eternity Bangle"] },
    ],
  },
  {
    slug: "diamond",
    label: "Diamond",
    tagline: "Certified diamonds — solitaire to statement.",
    cover: RING_IMAGES[3],
    subCategories: [
      { slug: "rings",    label: "Diamond Rings",    images: RING_IMAGES,    styleNames: ["Solitaire", "Halo", "Three Stone", "Cluster", "Eternity Band", "Vintage"] },
      { slug: "pendants", label: "Diamond Pendants & Chains", images: CHAIN_IMAGES, styleNames: ["Solitaire Pendant", "Halo Pendant", "Cluster Pendant", "Heart Pendant", "Cross Pendant", "Layered Set"] },
      { slug: "earrings", label: "Diamond Earrings", images: STUD_IMAGES,    styleNames: ["Solitaire Stud", "Halo Stud", "Drop", "Chandelier", "Cluster", "Hoop"] },
      { slug: "bangles",  label: "Diamond Bangles",  images: BANGLE_IMAGES,  styleNames: ["Tennis Bracelet", "Diamond Bangle", "Eternity Bangle", "Bridal Cuff", "Diamond Kada", "Charm Bracelet"] },
    ],
  },
  {
    slug: "gemstones",
    label: "Gemstones",
    tagline: "Ruby, emerald, sapphire & precious coloured stones.",
    cover: RING_IMAGES[2],
    subCategories: [
      { slug: "rings",    label: "Gemstone Rings",    images: RING_IMAGES,    styleNames: ["Ruby Solitaire", "Emerald Halo", "Sapphire Three Stone", "Cluster", "Cocktail Ring", "Signet"] },
      { slug: "pendants", label: "Gemstone Pendants", images: CHAIN_IMAGES,   styleNames: ["Ruby Pendant", "Emerald Drop", "Sapphire Solitaire", "Multi-stone", "Birthstone", "Layered Set"] },
      { slug: "earrings", label: "Gemstone Earrings", images: EARRING_IMAGES, styleNames: ["Ruby Studs", "Emerald Drops", "Sapphire Hoops", "Chandelier", "Danglers", "Statement"] },
      { slug: "bangles",  label: "Gemstone Bangles",  images: BANGLE_IMAGES,  styleNames: ["Ruby Bangle", "Emerald Bangle", "Sapphire Kada", "Multi-stone Bracelet", "Eternity Band", "Statement Cuff"] },
      { slug: "necklaces", label: "Gemstone Necklaces", images: NECKLACE_IMAGES, styleNames: ["Ruby Haar", "Emerald Choker", "Sapphire Layered", "Navratna", "Meenakari Set", "Statement Necklace"] },
    ],
  },
  {
    slug: "temple-antique",
    label: "Temple & Antique",
    tagline: "Heritage temple & antique jewellery.",
    cover: TEMPLE_IMAGES[0],
    subCategories: [
      { slug: "temple",    label: "Temple Jewellery",  images: TEMPLE_IMAGES,  styleNames: ["Lakshmi Haar", "Kasu Malai", "Bharatanatyam Set", "Temple Choker", "Vaddanam", "Nethi Chutti"] },
      { slug: "antique",   label: "Antique Jewellery", images: ANTIQUE_IMAGES, styleNames: ["Nizami", "Rajwada", "Vintage Kundan", "Polki Set", "Jadau", "Meenakari"] },
      { slug: "necklaces", label: "Temple & Antique Necklaces", images: NECKLACE_IMAGES, styleNames: ["Lakshmi Haar", "Kasu Malai", "Rani Haar", "Polki Haar", "Kundan Set", "Antique Choker"] },
    ],
  },
];

// ---------------- HELPERS ----------------
export const WA_NUMBER = "919503650463";
export const WA_BASE = `https://wa.me/${WA_NUMBER}`;
export const waLink = (name) =>
  `${WA_BASE}?text=${encodeURIComponent("Hi Alankar Jewellers, I'd like to know more about: " + name)}`;
export const waGeneric = `${WA_BASE}?text=${encodeURIComponent("Hi Alankar Jewellers, I have an enquiry.")}`;

const seeded = (n) => {
  const x = Math.sin(n * 9301 + 49297) * 233280;
  return x - Math.floor(x);
};

// Convert a string into a stable numeric seed
const strSeed = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
};

const weightForCategory = (categorySlug, subSlug, i) => {
  const base = {
    gold: { min: 3.2, max: 32 },
    "rose-gold": { min: 2.5, max: 18 },
    silver: { min: 4, max: 120 },
    diamond: { min: 1.8, max: 12 },
    "temple-antique": { min: 12, max: 85 },
  }[categorySlug] || { min: 2, max: 15 };
  const s = strSeed(categorySlug + subSlug) + i * 17;
  if (subSlug === "murti") return +(80 + seeded(s) * 320).toFixed(1);
  if (subSlug === "necklaces" || subSlug === "temple" || subSlug === "antique")
    return +(base.min + seeded(s) * (base.max - base.min) * 1.4).toFixed(2);
  return +(base.min + seeded(s + 3) * (base.max - base.min)).toFixed(2);
};

const purityForCategory = (categorySlug, subSlug, i) => {
  const options = {
    gold: ["22k", "18k", "24k", "22k", "18k"],
    "rose-gold": ["18k", "14k", "18k"],
    silver: ["92.5% Sterling", "999 Fine", "92.5% Sterling"],
    diamond: ["18k · VS1", "18k · SI1", "22k · VVS2", "18k · VS2"],
    "temple-antique": ["22k Antique", "22k Temple", "22k Kundan"],
  };
  const arr = options[categorySlug] || ["22k"];
  const s = strSeed(categorySlug + subSlug) + i * 7;
  return arr[Math.floor(seeded(s + 11) * arr.length)];
};

const hallmarkForCategory = (categorySlug) =>
  categorySlug === "silver"
    ? "925 BIS Hallmark"
    : categorySlug === "diamond"
    ? "IGI / SGL Certified"
    : "BIS Hallmark 916";

// ---------------- LOOKUPS ----------------
export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug) || null;
export const getSubCategory = (catSlug, subSlug) => {
  const cat = getCategory(catSlug);
  if (!cat) return null;
  return cat.subCategories.find((s) => s.slug === subSlug) || null;
};

// ---------------- DESIGN GENERATION ----------------
const DESIGN_COUNT = 54; // 50+ per sub-category

export const getDesigns = (catSlug, subSlug) => {
  const cat = getCategory(catSlug);
  const sub = getSubCategory(catSlug, subSlug);
  if (!cat || !sub) return [];
  return Array.from({ length: DESIGN_COUNT }, (_, i) => {
    const styleName = sub.styleNames[i % sub.styleNames.length];
    const number = String(i + 1).padStart(3, "0");
    const image = sub.images[i % sub.images.length];
    const video = VIDEO_POOL[i % VIDEO_POOL.length];
    const gallery = [
      sub.images[i % sub.images.length],
      sub.images[(i + 1) % sub.images.length],
      sub.images[(i + 2) % sub.images.length],
    ];
    return {
      id: `${catSlug}-${subSlug}-${number}`,
      number,
      name: `${sub.label} · ${styleName} ${number}`,
      styleName,
      image,
      gallery,
      video,
      weight: weightForCategory(catSlug, subSlug, i),
      weightUnit: "g",
      purity: purityForCategory(catSlug, subSlug, i),
      hallmark: hallmarkForCategory(catSlug),
      makingCharge: subSlug === "murti" ? "On request" : "From ₹ 250 / gm",
      priceNote: "Price on enquiry — subject to daily rate",
      category: { slug: cat.slug, label: cat.label },
      subCategory: { slug: sub.slug, label: sub.label },
    };
  });
};

export const getFeaturedByCategory = (catSlug, take = 3) => {
  const cat = getCategory(catSlug);
  if (!cat) return [];
  return getDesigns(catSlug, cat.subCategories[0].slug).slice(0, take);
};

// ---------------- SEARCH ----------------
export const searchDesigns = (query, limit = 60) => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const results = [];
  for (const cat of CATEGORIES) {
    for (const sub of cat.subCategories) {
      const designs = getDesigns(cat.slug, sub.slug);
      for (const d of designs) {
        if (
          d.name.toLowerCase().includes(q) ||
          d.styleName.toLowerCase().includes(q) ||
          sub.label.toLowerCase().includes(q) ||
          cat.label.toLowerCase().includes(q)
        ) {
          results.push(d);
          if (results.length >= limit) return results;
        }
      }
    }
  }
  return results;
};

// ---------------- DESIGN DETAIL LOOKUPS ----------------
export const getDesignById = (id) => {
  if (!id) return null;
  const parts = id.split("-");
  if (parts.length < 3) return null;
  const number = parts[parts.length - 1];
  const catSlug = parts[0];
  const subSlug = parts.slice(1, -1).join("-");
  const designs = getDesigns(catSlug, subSlug);
  return designs.find((d) => d.number === number) || null;
};

export const getDesignByParts = (catSlug, subSlug, number) => {
  const designs = getDesigns(catSlug, subSlug);
  return designs.find((d) => d.number === number) || null;
};

// Returns other designs from the same sub-category (skipping current one)
export const getRelatedDesigns = (design, count = 12) => {
  if (!design) return [];
  const list = getDesigns(design.category.slug, design.subCategory.slug);
  return list.filter((d) => d.id !== design.id).slice(0, count);
};

// Flat list of every built-in design (all categories × all sub-categories).
// Used by StylePage (weight filters) and the Admin "browse & edit built-in" grid.
export const getAllDesigns = () => {
  const out = [];
  for (const cat of CATEGORIES) {
    for (const sub of cat.subCategories) {
      out.push(...getDesigns(cat.slug, sub.slug));
    }
  }
  return out;
};

// URL helper — single source of truth for the design detail route
export const designUrl = (design) =>
  `/design/${design.category.slug}/${design.subCategory.slug}/${design.number}`;
